import { db } from '@/api/firebase'
import { DBRouteGeometry, RouteGeometry } from '../../models'

const geometryConverter: firebase.firestore.FirestoreDataConverter<RouteGeometry> = {
  toFirestore(geometry: RouteGeometry): DBRouteGeometry {
    return {
      legs: JSON.stringify(geometry.legs || [])
    }
  },
  fromFirestore(snap, options): RouteGeometry {
    const dbGeometry = snap.data(options) as DBRouteGeometry
    return {
      legs: JSON.parse(dbGeometry.legs) || []
    }
  },
}

const geometryRef = (routeId: string) => db.doc(`routes/${routeId}/data/geometry`).withConverter(geometryConverter)

export {
  geometryRef
}